export const API_BASE = 'https://barrierefrei-leben-terminal-backend.d03.lfda.de'

export const RESET_HIDDEN_TIMEOUT = 4 * 60 * 1000
export const RESET_MODAL_TIMEOUT = 20 * 1000
export const AUTOPLAY_TIMEOUT = 6 * 1000

export const STORAGE_KEY_SETTINGS = 'terminalSettings'
